export const HELP_KWIFF_EMAIL = 'help@kwiff.com';
export const HELP_BETKWIFF_EMAIL = 'help@betkwiff.com';

export const DEFAULT_MIN_SEARCH_TEXT_LENGTH = 3;

export const MAX_TRENDING_BETS_TO_SHOW = 5;

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong';

export const auth = {
  AUTHENTICATED: 1,
  LOGGINGIN: 0,
  SIGNUP: -1,
  UNAUTHENTICATED: -2,
  LOCATION_REJECTED: -3,
  LOCATION_DENIED: -4,
};

export const APP_INSTALL_PROMPT_TIMEOUT_MS = 2000;
